import { fg } from '@atlassian/jira-feature-gating';

type HostingProduct = 'jira-servicedesk' | 'jsm-cmdb';

export const getHostingProduct = (): HostingProduct =>
	fg('provide-hosting-product-for-assets') ? 'jira-servicedesk' : 'jsm-cmdb';
